import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal';
import ItemPicker from 'components/ItemPicker';
import TeamTypeFilter from 'components/TeamTypeFilter';
import { useFetchTeams, useFetchTeamTypes } from '../../actions/team';
import renderTeamTypeIcon from './renderTeamTypeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
function TeamPickerModal(_ref) {
  var onSubmit = _ref.onSubmit,
    onClose = _ref.onClose,
    _ref$defaultSelectedI = _ref.defaultSelectedItems,
    defaultSelectedItems = _ref$defaultSelectedI === void 0 ? [] : _ref$defaultSelectedI,
    _ref$defaultIndetermi = _ref.defaultIndeterminateItems,
    defaultIndeterminateItems = _ref$defaultIndetermi === void 0 ? [] : _ref$defaultIndetermi,
    _ref$disabledItems = _ref.disabledItems,
    disabledItems = _ref$disabledItems === void 0 ? [] : _ref$disabledItems,
    selectableItemIds = _ref.selectableItemIds,
    _ref$renderItemSubtit = _ref.renderItemSubtitle,
    renderItemSubtitle = _ref$renderItemSubtit === void 0 ? function () {
      return undefined;
    } : _ref$renderItemSubtit,
    _ref$onBeforeChange = _ref.onBeforeChange,
    onBeforeChange = _ref$onBeforeChange === void 0 ? function () {
      return false;
    } : _ref$onBeforeChange,
    _ref$allowSubmitWitho = _ref.allowSubmitWithoutChanges,
    allowSubmitWithoutChanges = _ref$allowSubmitWitho === void 0 ? false : _ref$allowSubmitWitho,
    _ref$userIds = _ref.userIds,
    userIds = _ref$userIds === void 0 ? [] : _ref$userIds,
    hideSmartTeamsFromSelector = _ref.hideSmartTeamsFromSelector,
    disableSmartTeamsInSelector = _ref.disableSmartTeamsInSelector;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var labels = {
    getSelectionStatus: function getSelectionStatus(count) {
      return t('team_selection_status', {
        count: count
      });
    },
    searchLabel: t('actions_search_teams'),
    searchPlaceholder: t('actions_search_teams')
  };
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedTeamType = _useState4[0],
    setSelectedTeamType = _useState4[1];
  var _useFetchTeamTypes = useFetchTeamTypes(),
    teamTypes = _useFetchTeamTypes.items;
  var renderFilter = function renderFilter() {
    return /*#__PURE__*/_jsx(TeamTypeFilter, {
      value: selectedTeamType,
      onChange: function onChange(value) {
        return setSelectedTeamType(value);
      },
      teamTypes: teamTypes
    });
  };

  // Undefined shows all teams by default
  var showSmartTeams = hideSmartTeamsFromSelector ? !hideSmartTeamsFromSelector : undefined;
  var _useFetchTeams = useFetchTeams({
      search: searchValue,
      teamTypeId: selectedTeamType,
      userIds: userIds,
      teamIds: selectableItemIds || null,
      filter: {
        isSmartTeam: showSmartTeams
      }
    }),
    items = _useFetchTeams.items,
    hasNextPage = _useFetchTeams.hasNextPage,
    fetchNextPage = _useFetchTeams.fetchNextPage,
    isError = _useFetchTeams.isError,
    isLoading = _useFetchTeams.isLoading,
    isFetchingNextPage = _useFetchTeams.isFetchingNextPage;
  var allAvailableTeams = [].concat(_toConsumableArray(items), _toConsumableArray(defaultSelectedItems), _toConsumableArray(defaultIndeterminateItems));
  var allSmartTeams = allAvailableTeams.filter(function (team) {
    return team === null || team === void 0 ? void 0 : team.isSmartTeam;
  });
  var disabledTeams = disableSmartTeamsInSelector ? [].concat(_toConsumableArray(disabledItems), _toConsumableArray(allSmartTeams)) : disabledItems;
  return /*#__PURE__*/_jsx(Modal, {
    id: "team-picker-modal",
    "aria-label": t('actions_select_teams'),
    onRequestClose: onClose,
    children: /*#__PURE__*/_jsx(ItemPicker, {
      title: t('actions_select_teams'),
      labels: labels,
      disabledItems: disabledTeams,
      defaultSelectedItems: defaultSelectedItems,
      defaultIndeterminateItems: defaultIndeterminateItems,
      onSearchValueChange: setSearchValue,
      renderItemIcon: teamTypes.length > 1 ? renderTeamTypeIcon : null,
      renderFilterMenu: teamTypes.length > 1 ? renderFilter : null,
      onSubmit: onSubmit,
      onClose: onClose,
      items: items,
      hasNextPage: hasNextPage,
      onFetchNextPage: fetchNextPage,
      isFetchingNextPage: isFetchingNextPage,
      isError: isError,
      isLoading: isLoading,
      renderItemSubtitle: renderItemSubtitle,
      onBeforeChange: onBeforeChange,
      allowSubmitWithoutChanges: allowSubmitWithoutChanges
    })
  });
}
export default TeamPickerModal;